import { render, staticRenderFns } from "./Query_result.vue?vue&type=template&id=04ac9268&"
import script from "./Query_result.vue?vue&type=script&lang=js&"
export * from "./Query_result.vue?vue&type=script&lang=js&"
import style0 from "./Query_result.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports